import React from 'react';
import { ReactComponent as Lamp } from '../../assets/images/icons/lamp.svg';

export default function LampIcon(props) {
  return (
    <Lamp className={`icon ${props.className}`} />
  );
}
